import { render, staticRenderFns } from "./email-field.vue?vue&type=template&id=cadd7ed8&scoped=true&lang=pug"
import script from "./email-field.vue?vue&type=script&lang=js"
export * from "./email-field.vue?vue&type=script&lang=js"
import style0 from "./email-field.vue?vue&type=style&index=0&id=cadd7ed8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadd7ed8",
  null
  
)

export default component.exports